import type {AiChatCallbacks, GeneratedImageEvent, HostEvent, PublishingOptionChosenEvent} from '@AiChat/callbacks/ai-chat-callbacks.types';
import type {ChatMessage, ChatMessageModelImagePart, ChatMessageTextPart, HostStreamEvent, ImageStreamEvent} from '@Components/ai-chat-window/ai-chat-window.types';
import {ChatMessagePartType} from '@Components/ai-chat-window/ai-chat-window.types';

export function toGeneratedImageEvent(event: ImageStreamEvent): GeneratedImageEvent | null {
  const imageParts = getGeneratedImageParts(event);

  if (imageParts.length === 0) {
    return null;
  }

  const firstPart = imageParts[0];

  return {
    chatId: event.idAiChat,
    messageId: event.message.messageId ?? null,
    hashedIds: imageParts.map((part) => part.hashedId).filter((hashedId) => hashedId !== ''),
    width: firstPart.width,
    height: firstPart.height,
    isFirstGeneration: event.showFirstImageGenerationDelight,
  };
}

export function toHostEvent(event: HostStreamEvent): HostEvent {
  return {chatId: event.idAiChat, type: event.type, data: event.data ?? null};
}

export function getFailedMessageText(message: ChatMessage): string {
  const textParts = message.parts.filter((part): part is ChatMessageTextPart => {
    return part.type === ChatMessagePartType.TEXT;
  });

  return textParts.map((part) => part.text).join(' ');
}

function getGeneratedImageParts(event: ImageStreamEvent): ChatMessageModelImagePart[] {
  return event.message.parts.filter((part): part is ChatMessageModelImagePart => {
    return part.type === ChatMessagePartType.MODEL_GENERATED_IMAGE && !part.isSkeletonPlaceholder;
  });
}

/** Shared by the publish paths so each fires the same event shape. A throwing host callback is logged and never blocks the publish. */
export function firePublishingOptionChosen(callbacks: AiChatCallbacks, event: PublishingOptionChosenEvent): void {
  try {
    callbacks.onPublishingOptionChosen?.(event);
  } catch (error: unknown) {
    console.error('Host onPublishingOptionChosen callback failed; publishing anyway', error);
  }
}
